export default "__VITE_ASSET__59502b84__"